<template>
    <section class="font-poppins">
        <div class="flex justify-between md:flex-col" style="height:83vh">
            <div class="w-2/3 lg:w-full">
                <div class="flex justify-around mt-8 ">
                    <router-link to="/"><img class=" md:w-1/2 w-4/5 pl-3"
                            src="https://res.cloudinary.com/https-carrygo-com/image/upload/v1634105033/carrygoWebAssets/carrygo_logo_vrdtw8.svg"
                            alt="logo"></router-link>
                    <p class="mr-10 text-blue-600 text-2xl md:text-sm">1/4</p>
                </div>

                <div class="flex justify-center md:pl-2 md:flex-col md:w-4/5 lg:m-auto ">
                    <div>
                        <div class="text-4xl md:text-lg mt-10 flex justify-content-center">
                            <h2 class="text-blue-600 font-semibold" style="color:rgb(18,84,179)">Sign Up for HP Scheme
                            </h2>
                        </div>
                        <div class="w-4/5 md:w-full">

                            <!-- PHONE VERIFICATION -->
                            <div>
                                <form @submit.prevent="_verifyNumber">
                                    <div class="mt-8 font-semibold">
                                        <p>Enter your Phone Number</p>
                                    </div>
                                    <p class="text-xs text-green-500" v-show="isCodeSent">Code sent successfully.</p>
                                    <p class="text-xs text-green-500">{{ otpStatus }}</p>
                                    <p class="text-xs text-red-500">{{ codeFailed }}</p>
                                    <div class="mt-5">
                                        <label for="phone">Phone Number</label> <br>
                                        <div class="mt-2 ">
                                            <div class="flex">
                                                <select class="p-1 rounded-lg" style="border:1px solid rgb(18,84,179) "
                                                    @change="selectedCode($event)">
                                                    <option value="+234">NG (+234)</option>
                                                    <option v-for="code in countryCode" :key="code"
                                                        :value="code.dial_code"><span
                                                            class="text-blue-500">{{ code.code }}</span>
                                                        ({{ code.dial_code }})</option>
                                                </select>
                                                <div>
                                                    <input v-model="number" style="border:1px solid rgb(18,84,179) "
                                                        class="w-full border p-1 ml-2 rounded-lg" type="number"
                                                        name="number" id="number">
                                                </div>
                                            </div>
                                            <p v-show="numberValidity" class="text-xs text-red-500">please enter phone
                                                number</p>
                                            <p class="text-xs text-red-500">{{ note }}</p>
                                        </div>
                                        <div class="mt-3">
                                            <input class="w-full border bg-gray-100 p-2 rounded-lg text-sm"
                                                type="number" name="code" id="code" placeholder="Enter code"
                                                v-model="otp">
                                            <p v-show="codeValidity" class="text-xs text-red-500">please enter code</p>
                                            <span class="text-xs ml-1 cursor-pointer" style="color:rgb(18,84,179)"><a
                                                    @click="checkNumber">Send Code </a></span>
                                            <p class="text-sm text-red-500">{{ displayError }}</p>
                                        </div>

                                        <div class="mt-10 flex">
                                            <button class="w-full text-white rounded p-1"
                                                style="background-color:rgb(18,84,179)">Proceed</button>
                                            <p v-if="isLoading"
                                                class="ml-2 mt-2 animate-spin rounded-full h-6 w-6 border border-t-2 border-b-2 border-blue-900 ">
                                            </p>
                                        </div>

                                        <div class="mt-5 mb-20 text-sm text-center">
                                            <p>Already have an account?
                                                <a style="text-decoration: none "
                                                    href="https://play.google.com/store/apps/details?id=org.carrygo.user"><span
                                                        class="text-blue-500">Login</span></a>
                                            </p>
                                        </div>
                                    </div>
                                </form>
                            </div>


                        </div>
                    </div>
                </div>
            </div>

            <div class="image w-1/3 md:hidden">

            </div>
        </div>

        <div class="lg:hidden ">
            <the-footer />
        </div>
        <ComingSoonModal v-show="isModalVisible" @click="close" />
    </section>
</template>

<script>
import axios from 'axios';
import ComingSoonModal from '../../ComingSoonModal.vue';
import { baseUrl } from '../../../../Config';
const url = baseUrl;
export default {
    components: { ComingSoonModal },
    data() {
        return {
            code: "+234",
            number: "",
            otp: "",
            emailOtp: "",
            mobileNumber: "",
            numberValidity: false,
            codeValidity: false,
            isLoading: false,
            countryCode: [],
            displayError: "",
            isCodeSent: false,
            codeFailed: "",
            isModalVisible: false,
            email: "",
            emailValidity: "",
            emailError: "",
            isEmailTaken: false,
            note: "",
            isOtpSent: false,
            otpStatus: "",
        }
    },

    mounted() {
        this.networkError();
        this.getCountryCode();
    },

    methods: {
        close() {
            this.isModalVisible = false
        },
        showModal() {
            this.isModalVisible = true
        },
        selectedCode(event) {
            this.code = event.target.value;
        }, networkError() {
            if (!navigator.onLine) {
                this.$router.push('/network-error')
            }
        },
        getCountryCode() {
            axios({
                method: 'GET',
                url: 'https://countriesnow.space/api/v0.1/countries/codes',
            })
                .then((response) => {
                    this.countryCode = response.data.data;
                })
        },


        checkNumber() {
            this.networkError();
            this.mobileNumber = this.code + this.number;
            localStorage.setItem("hpPhone", this.mobileNumber);
            if (this.isOtpSent == true && this.mobileNumber.includes(this.number)) {
                this.otpStatus = "OTP code already sent. "
                setTimeout(() => {
                    this.otpStatus = "";
                }, 3000);
            } else if (!this.number) {
                this.note = "Please enter phone number"
                setTimeout(() => {
                    this.note = "";
                }, 3000);
            } else {
                this.mobileNumber = this.code + this.number;
                localStorage.setItem("hpPhone", this.mobileNumber);
                axios({
                    method: 'GET',
                    url: `${url}/v1/web/users/phone/check/${this.mobileNumber}`,
                    headers: {
                        'Content-type': 'application/json',
                        'cg-key': '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                    },
                })
                    .then((response) => {
                        response.json;
                        this.sendCode();
                    })
                    .catch((error) => {
                        if (error.response.data.status == false) {
                            this.codeFailed = "Phone Number Already Exists";
                            setTimeout(() => {
                                this.codeFailed = "";
                            }, 3000);
                        }
                    })
            }
        },

        sendCode() {
            this.networkError();
            this.mobileNumber = this.code + this.number;
            localStorage.setItem("hpPhone", this.mobileNumber);
            axios({
                method: 'POST',
                url: `${url}/v1/web/auth/otp/send`,
                headers: {
                    'Content-type': 'application/json',
                    'cg-key': '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
                data: {
                    mobileNumber: String(this.mobileNumber)
                }
            })
                .then((response) => {
                    response.json;
                    this.isCodeSent = true;
                    setTimeout(() => {
                        this.isCodeSent = false;
                    }, 3000);
                    this.isOtpSent = true;

                })
                .catch((error) => {
                    this.codeFailed = error.response.data.message;
                    setTimeout(() => {
                        this.codeFailed = "";
                    }, 3000);
                })
        },



        _verifyNumber() {
            this.networkError();
            this.mobileNumber = this.code + this.number;
            if (this.number === "") {
                this.numberValidity = true;
                setTimeout(() => {
                    this.numberValidity = false;
                }, 4000);
            } else if (!this.otp) {
                this.codeValidity = true;
                setTimeout(() => {
                    this.codeValidity = false;
                }, 4000);
            } else {
                this.isLoading = true;
                axios({
                    method: 'POST',
                    url: `${url}/v1/web/auth/otp/verify`,
                    headers: {
                        'Content-type': 'application/json',
                        'cg-key': '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                    },
                    data: {
                        mobileNumber: this.mobileNumber,
                        otp: String(this.otp)
                    }
                })
                    .then((res) => {
                        this.$router.push("/rider-email-verification")
                        this.isLoading = false
                        res.json
                    })
                    .catch((error) => {
                        this.displayError = error.response.data.message;
                        setTimeout(() => {
                            this.displayError = "";
                        }, 3000);
                        this.isLoading = false;

                    })
            }

        },

        //  _verifyNumber() {
        //      this.mobileNumber = this.code + this.number;
        //     localStorage.setItem("hpPhone", this.mobileNumber);
        //     if(!this.number) {
        //         this.numberValidity = 'invalid';
        //          setTimeout(() => {
        //             this.numberValidity = "";
        //         }, 3000);
        //     } else {
        //         this.$router.push("/rider-email-verification")
        //     }
        //}
    }

}
</script>

<style scoped>
.image {
    background-image: url("../Image/sea.png");
    background-repeat: no-repeat;
}
</style>
